export const AdditionalInformation = {
  REQUEST: 'ServiceRequests/AdditionalInformation/Request',
  SUCCESS: 'ServiceRequests/AdditionalInformation/Success',
  FAILURE: 'ServiceRequests/AdditionalInformation/Failure'
};

export const CalculateByDays = {
  REQUEST: 'ServiceRequests/CalculateByDays/Request',
  SUCCESS: 'ServiceRequests/CalculateByDays/Success',
  FAILURE: 'ServiceRequests/CalculateByDays/Failure'
};

export const CLEAR_COSTS = {
  REQUEST: 'ServiceRequests/ClearCosts/Request',
  SUCCESS: 'ServiceRequests/ClearCosts/Success',
  FAILURE: 'ServiceRequests/ClearCosts/Failure'
};

export const ForSubmit = {
  REQUEST: 'ServiceRequests/ForSubmit/Request',
  SUCCESS: 'ServiceRequests/ForSubmit/Success',
  FAILURE: 'ServiceRequests/ForSubmit/Failure'
};

export const CREATE = {
  REQUEST: 'ServiceRequests/Create/Request',
  SUCCESS: 'ServiceRequests/Create/Success',
  FAILURE: 'ServiceRequests/Create/Failure'
};

export const GET = {
  REQUEST: 'ServiceRequests/Get/Request',
  SUCCESS: 'ServiceRequests/Get/Success',
  FAILURE: 'ServiceRequests/Get/Failure'
};

export const UPDATE = {
  REQUEST: 'ServiceRequests/Update/Request',
  SUCCESS: 'ServiceRequests/Update/Success',
  FAILURE: 'ServiceRequests/Update/Failure'
};

export const REMOVE = {
  REQUEST: 'ServiceRequests/Remove/Request',
  SUCCESS: 'ServiceRequests/Remove/Success',
  FAILURE: 'ServiceRequests/Remove/Failure'
};

export const GETCATEGORYSERVICEREQUEST = {
  REQUEST: 'ServiceRequests/GetCategoryServiceRequest/Request',
  SUCCESS: 'ServiceRequests/GetCategoryServiceRequest/Success',
  FAILURE: 'ServiceRequests/GetCategoryServiceRequest/Failure'
};

export const GETCATEGORYSUBITEMS = {
  REQUEST: 'ServiceRequests/GetCategorySubitems/Request',
  SUCCESS: 'ServiceRequests/GetCategorySubitems/Success',
  FAILURE: 'ServiceRequests/GetCategorySubitems/Failure'
};

export const CREATECATEGORYSPLIT = {
  REQUEST: 'ServiceRequests/CreateCategorySplit/Request',
  SUCCESS: 'ServiceRequests/CreateCategorySplit/Success',
  FAILURE: 'ServiceRequests/CreateCategorySplit/Failure'
};

export const RESOLVECATEGORYREQUEST = {
  REQUEST: 'ServiceRequests/ResolveCategoryRequest/Request',
  SUCCESS: 'ServiceRequests/ResolveCategoryRequest/Success',
  FAILURE: 'ServiceRequests/ResolveCategoryRequest/Failure'
};

export const REOPENCATEGORYREQUEST = {
  REQUEST: 'ServiceRequests/ReopenCategoryRequest/Request',
  SUCCESS: 'ServiceRequests/ReopenCategoryRequest/Success',
  FAILURE: 'ServiceRequests/ReopenCategoryRequest/Failure'
};

export const GET_FOOTER = {
  REQUEST: 'ServiceRequests/GetFooter/Request',
  SUCCESS: 'ServiceRequests/GetFooter/Success',
  FAILURE: 'ServiceRequests/GetFooter/Failure'
};

export const CALCULATE_BY_DAYS_FROM_CATALOG = {
  REQUEST: 'ServiceRequests/CalculateByDaysForCatalog/Request',
  SUCCESS: 'ServiceRequests/CalculateByDaysForCatalog/Success',
  FAILURE: 'ServiceRequests/CalculateByDaysForCatalog/Failure'
};

export const CLEAR_FOOTER = {
  SUCCESS: 'ServiceRequests/ClearFooter/Success'
};

export const CONFIRM = {
  REQUEST: 'ServiceRequests/Confirm/Request',
  SUCCESS: 'ServiceRequests/Confirm/Success',
  FAILURE: 'ServiceRequests/Confirm/Failure'
};

export const GET_INTERNAL_PENDING_FLAG = {
  REQUEST: 'ServiceRequests/GetInternalPendingFlag/Request',
  SUCCESS: 'ServiceRequests/GetInternalPendingFlag/Success',
  FAILURE: 'ServiceRequests/GetInternalPendingFlag/Failure'
};

export const UPDATE_INTERNAL_PENDING_FLAG = {
  REQUEST: 'ServiceRequests/UpdateInternalPendingFlag/Request',
  SUCCESS: 'ServiceRequests/UpdateInternalPendingFlag/Success',
  FAILURE: 'ServiceRequests/UpdateInternalPendingFlag/Failure'
};

export const UPDATE_ACTIVITY = {
  REQUEST: 'ServiceRequests/UpdateActivity/Request',
  SUCCESS: 'ServiceRequests/UpdateActivity/Success',
  FAILURE: 'ServiceRequests/UpdateActivity/Failure'
};

export const GET_EXCLUDE_FROM_FSOR_CONFIRMATION = {
  REQUEST: 'ServiceRequests/GetExcludeFromFsorConfirmation/Request',
  SUCCESS: 'ServiceRequests/GetExcludeFromFsorConfirmation/Success',
  FAILURE: 'ServiceRequests/GetExcludeFromFsorConfirmation/Failure'
};

export const UPDATE_EXCLUDE_FROM_FSOR_CONFIRMATION = {
  REQUEST: 'ServiceRequests/ExcludeFromFsorConfirmation/Request',
  SUCCESS: 'ServiceRequests/ExcludeFromFsorConfirmation/Success',
  FAILURE: 'ServiceRequests/ExcludeFromFsorConfirmation/Failure'
};

export const UPDATE_GENERAL_ATTACHMENTS = {
  REQUEST: 'ServiceRequests/UpdateGeneralAttachments/Request',
  SUCCESS: 'ServiceRequests/UpdateGeneralAttachments/Success',
  FAILURE: 'ServiceRequests/UpdateGeneralAttachments/Failure'
};

export const GET_IS_FULLY_ORDERED = {
  REQUEST: 'ServiceRequests/GetIsFullyOrdered/Request',
  SUCCESS: 'ServiceRequests/GetIsFullyOrdered/Success',
  FAILURE: 'ServiceRequests/GetIsFullyOrdered/Failure'
};

export const UPDATE_IS_FULLY_ORDERED = {
  REQUEST: 'ServiceRequests/UpdateIsFullyOrdered/Request',
  SUCCESS: 'ServiceRequests/UpdateIsFullyOrdered/Success',
  FAILURE: 'ServiceRequests/UpdateIsFullyOrdered/Failure'
};

export const VALIDATE_SERVICE_REQUESTS_FOR_COPY = {
  REQUEST: 'ServiceRequests/ValidateServiceRequestsForCopy/Request',
  SUCCESS: 'ServiceRequests/ValidateServiceRequestsForCopy/Success',
  FAILURE: 'ServiceRequests/ValidateServiceRequestsForCopy/Failure'
};

export const GET_DATA_FOR_COPY_SUBMIT = {
  REQUEST: 'ServiceRequests/GetDataForCopySubmit/Request',
  SUCCESS: 'ServiceRequests/GetDataForCopySubmit/Success',
  FAILURE: 'ServiceRequests/GetDataForCopySubmit/Failure'
};

export const COPY_SERVICE_REQUESTS = {
  REQUEST: 'ServiceRequests/CopyServiceRequests/Request',
  SUCCESS: 'ServiceRequests/CopyServiceRequests/Success',
  FAILURE: 'ServiceRequests/CopyServiceRequests/Failure'
};

export const VALIDATE_EXERCISE_FOR_SR_COPY = {
  REQUEST: 'ServiceRequests/ValidateExerciseForSrCopy/Request',
  SUCCESS: 'ServiceRequests/ValidateExerciseForSrCopy/Success',
  FAILURE: 'ServiceRequests/ValidateExerciseForSrCopy/Failure'
};

export const ROLLBACK_SERVICE_REQUEST = {
  REQUEST: 'ServiceRequests/RollbackServiceRequest/Request',
  SUCCESS: 'ServiceRequests/RollbackServiceRequest/Success',
  FAILURE: 'ServiceRequests/RollbackServiceRequest/Failure'
};
